import React from "react";
import { useState, useEffect, useMemo, useRef } from "react"
import { useTranslation } from "react-i18next";
import {
  Button,
  ButtonHLPure,
  DialogSystemGLPure,
  GridHLPure,
  GridSimpleReadHLPure,
  SimpleLoading,
  DialogPdfHLPure,
  Label,
  DialogPdf,
  GridSelectionHLPure,
  TooltipHLPure,
  DialogYesNoHLPure,
  SyncfusionPDFViewer,
  DialogFormHLPure,
  LabelErrorPure,
  LabelHLPure
} from "../../pures";
import InteractiveDialog from "../../pures/InteractiveDialog/InteractiveDialog"
import './contracting-registration-documents.view.css'
import { Grid } from "@material-ui/core";
import PdfViewerAction from '../../actions/pdf-viewer/pdf-viewer.action'
import { ContractorService } from "../../../services";
import { b64toBlob } from "./../../../validators";
import { useMediaQuery } from "@material-ui/core";
import { ArrowBtnMobile } from '../../../assets/logos/icons'


const ContractingRegistrationDocumentsView = (props) => {
  const { t } = useTranslation();
  const { url, token, step, onHandleBack, onHandleNext, showLoadingRequesting, showCompletedRequesting, showErrorRequesting, toggleLoadingRequesting, toggleCompletedRequesting, toggleErrorRequesting, idContractor, typePersonId, handleFile, handleDeleteFile, handleSetNameDocument, isFreelanceView, documentsFree, handleUploadDocFree, getFreelanceData, uploadFormAnwsered } = props;
  const { next, back } = step;
  const [selectedDocumentGrid, setSelectedDocumentGrid] = useState({});
  const [fileBase64, setFileBase64] = useState("");
  const [isLoading] = useState(false)
  let profileDoc = [{ documentName: '', document: {} }]
  const [profiles, setProfiles] = useState(profileDoc)
  const [dataItemSelected, setDataItemSelected] = useState({})
  const inputFileRef = useRef(null)
  const [fileSelected, setFileSelected] = useState('')
  const [message, setMessage] = useState('')
  const [dataDocuments, setDataDocuments] = useState([])
  const [blobUrl, setBlobUrl] = useState("");
  const [showPdf, setShowPdf] = useState(false)
  const [urlPdf, setUrlPdf] = useState('')
  const [blob, setBlob] = useState("");
  const [currentSystem, setCurrentSystem] = useState("");
  const [selectedFileBase64, setSelectedFileBase64] = useState('')
  const [showModalPdf, setShowModalPdf] = useState(false)
  const [documentSelected, setDocumentSelected] = useState({})
  const [loadingDialog, setLoadingDialog] = useState(false)
  const [showAWS, setShowAws] = useState(true)
  const [showModalDelete, setShowModalDelete] = useState(false)
  const [showModalForms, setShowModalForms] = useState(false)
  const [pathDocumentSync, setPathDocumentSync] = useState('')
  const [pathToSaveSync, setPathToSave] = useState('')
  const [errorExtensionFile, setErrorExtensionFile] = useState(false)
  const [files, setFiles] = useState(null)

  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");
  const mobileResolution = useMediaQuery("(max-width:560px)");
  const is820 = useMediaQuery("(max-width:820px)");

  const pdfAws = useMemo(() => <PdfViewerAction url={urlPdf} isExtended={false} isSSRActive={false} />, [urlPdf])
  const pdf = useMemo(() => {
    const pdfUrl = selectedFileBase64 ? `data:application/pdf;base64,${selectedFileBase64}` : '';
    return <PdfViewerAction url={pdfUrl} isExtended={false} isSSRActive={false} />
  }, [selectedFileBase64])


  let heightContainer = mobileResolution ? 450 : 800
  let widthContainer = mobileResolution ? 550 : 1000
  let heightBody = mobileResolution ? 230 : 520
  let widthColumnOne = 200
  let widthColumnFive = 100
  let showIcon = true

  if (is820) {
    widthColumnOne = 100
    showIcon = false
  }

  if (mobileResolution) {
    widthColumnOne = 200
    widthColumnFive = 70
  }

  const headerColumnOneForms = (props) => {
    return <span className="contractingRegistrationDocumentsView-header-cell-one">{props.title}</span>;
  };

  const headerColumnTwoForms = (props) => {
    return <span className="contractingRegistrationDocumentsView-header-cell-two">{props.title}</span>;
  };

  const cellColumnOneForms = (props) => {
    let subtitle = (props.dataItem.dateToShow && props.dataItem.dateToShow !== '') ? `${t("contractingRegistrationDataView.grid.registeredThe")} ${props.dataItem.dateToShow}` : props.dataItem.status
    return (
      <td className={`contractingRegistrationDocumentsView-cell-one ${props.dataItem.selected ? "contractingRegistrationDocumentsView-cell-selected" : ""}`} onClick={() => onClickSelectRow(props.dataItem)}>
        <div className="contractingRegistrationDocumentsView-container-cell-one">
          <div className="contractingRegistrationDocumentsView-container-span">
            <span className="contractingRegistrationDocumentsView-span-name">
              {props.dataItem.name}
            </span>
            {
              showIcon ?
                <TooltipHLPure
                  positionTooltip={'right'}
                  titleTooltip={props.dataItem.name}
                  descriptionTooltip={props.dataItem.description}
                  informationIcon={true}
                />
                : null
            }
          </div>
          <div>
            <span>
              {subtitle}
            </span>
          </div>
        </div>
      </td>
    );
  };

  const cellColumnTwoForms = (props) => {
    return (
      <td className={`documentPanelBarExpediente-cell-two ${props.dataItem.selected ? "contractingRegistrationDocumentsView-cell-selected" : ""}`} onClick={() => onClickSelectRow(props.dataItem)}>
        <div className="contractingRegistrationDocumentsView-btns-grid">
          <div className={"cellActions-containerBtnsDetails"}>
            <button
              className="cellActions-btn"
              onClick={(props.dataItem.isForm) ? () => handleOpenModalForms(props.dataItem) : () => openModalDelete(props.dataItem)}
            >
              <p className="cellActions-textBotton">{(props.dataItem.isForm) ? t("contractingRegistrationDocumentsView.btn.form") : t("contractingRegistrationDocumentsView.label.cell.5")}</p>
            </button>
          </div>
          {
            !props.dataItem.isForm && (
              <div className={"cellActions-containerBtnsDetails"}>
                <button
                  className="cellActions-btn"
                  onClick={() => handleOnClickGrid(props.dataItem)}
                >
                  <p className="cellActions-textBotton">{t("contractingRegistrationDocumentsView.label.cell.1")}</p>
                </button>
              </div>
            )
          }
        </div>
      </td>
    )
  }

  let heightGrid = '100%'

  // if(documentsFree.length === 1 || documentsFree.length === 0){
  //     heightGrid = '110px'
  // }else if(documentsFree.length === 2){
  //     heightGrid = '180px'
  // }else if(documentsFree.length === 3){
  //     heightGrid = '280px'
  // }else{
  //     heightGrid = '320px'
  // }

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  useEffect(() => {
    if (props.selectedFileBase64) {
      const blob = b64toBlob(props.selectedFileBase64, "application/pdf");
      setBlobUrl(blob);
      setSelectedFileBase64(props.selectedFileBase64)
    }
  }, [props.selectedFileBase64]);

  useEffect(() => {
    if (idContractor && typePersonId) {
      toggleLoadingRequesting(true)
      getContractorClientDocument()
    }
  }, [typePersonId, idContractor])

  //get documents client when update a document
  const getContractorClientDocument = async () => {
    let documents = []
    try {
      let contractorService = new ContractorService(url)
      let contractorClientDocument = await contractorService.getContractorClientDocuments(idContractor, token)
      if (contractorClientDocument && contractorClientDocument.data && contractorClientDocument.data.data && Number(contractorClientDocument.data.statusCode) === 200) {
        for (let index = 0; index < contractorClientDocument.data.data.length; index++) {
          let info = {}
          info.id = contractorClientDocument.data.data[index].id
          info.clientDocumentId = contractorClientDocument.data.data[index].clientDocumentId
          info.name = contractorClientDocument.data.data[index].clientDocument.clientDocumentTypeRequestId === 2 ? `${contractorClientDocument.data.data[index].clientDocument.name} *` : contractorClientDocument.data.data[index].clientDocument.name
          info.description = contractorClientDocument.data.data[index].clientDocument.description
          info.userId = contractorClientDocument.data.data[index].userId
          info.path = contractorClientDocument.data.data[index].path
          info.dateToShow = contractorClientDocument.data.data[index].documentWasLoaded === true ? contractorClientDocument.data.data[index].updatedDate : ''
          info.createdDate = contractorClientDocument.data.data[index].createdDate
          info.updatedDate = contractorClientDocument.data.data[index].updatedDate
          info.status = contractorClientDocument.data.data && contractorClientDocument.data.data[index].documentWasLoaded === true ? t("contractingRegistrationDataView.grid.registeredThe") : t("contractingRegistrationDataView.grid.pending")
          info.documentWasLoaded = contractorClientDocument.data.data[index].documentWasLoaded
          info.clientDocumentTypeRequestId = contractorClientDocument.data.data[index].clientDocument.clientDocumentTypeRequestId
          documents.push(info)
        }

        documents = documents.sort((a, b) => {
          if ((a.documentWasLoaded && !b.documentWasLoaded)) return -1
          if ((!a.documentWasLoaded && b.documentWasLoaded)) return 1

          if ((a.clientDocumentTypeRequestId === 2 && !b.clientDocumentTypeRequestId !== 2)) return -1
          if ((b.clientDocumentTypeRequestId !== 2 && b.clientDocumentTypeRequestId === 2)) return 1

          return 0
        })

        setDataDocuments(documents)
        toggleLoadingRequesting(false)
      }

    } catch (error) {
      console.log(error)
      toggleLoadingRequesting(false)
      toggleLoadingRequesting(false)
      setMessage('Ocurrió un error al traer los documentos')
      toggleErrorRequesting(true)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 2000)
    }
  }


  //Function to btn continue
  const hanldeContinueBtn = (e) => {
    let allDocumentsWasNotUpload = false
    for (let index = 0; index < dataDocuments.length; index++) {
      if (dataDocuments[index].documentWasLoaded === false && dataDocuments[index].clientDocumentTypeRequestId === 2) {
        allDocumentsWasNotUpload = true
      }
    }

    if (allDocumentsWasNotUpload === true) {
      setMessage(t("contractingRegistrationDocumentsView-error-not-upload-all-douments"))
      toggleErrorRequesting(true)
      setTimeout(() => {
        toggleErrorRequesting(false)
        setMessage('')
      }, 5000)
    } else {
      onHandleNext(e)
    }

  }

  //function to upload pdf 
  const handleOnChangeUpload = async (e) => {
    setShowModalPdf(false)
    toggleLoadingRequesting(true)
    setErrorExtensionFile(false)

    const validExtensions = ['pdf']
    const file = e.target.files[0]
    const fileName = (file && file.name) ? file.name : ''
    const extension = fileName.split('.').pop().toLowerCase()

    if (!file || !validExtensions.includes(extension)) {
      setErrorExtensionFile(true)
      setLoadingDialog(false)
      return
    }

    let userId = documentSelected.userId
    let clientDocumentId = documentSelected.clientDocumentId
    let userDocument = new FormData();
    userDocument.append("userDocument", file);
    userDocument.append("clientDocumentId", clientDocumentId);
    userDocument.append("userId", userId);
    userDocument.append("contractorId", idContractor);

    try {
      let contractorService = new ContractorService(url)
      let updatedDocument = await contractorService.updateContractorClientDocument(userDocument, token)
      if (updatedDocument && updatedDocument.data && updatedDocument.data.data && Number(updatedDocument.data.statusCode) === 200) {
        setShowAws(false)
        getContractorClientDocument()
        setProfiles([{
          documentName: '',
          document: null,
          upload: ''
        }])
        toggleLoadingRequesting(false)
      } else {
        toggleLoadingRequesting(false)
        toggleErrorRequesting(true, 4000)
      }
    } catch (error) {
      showModalPdf(true)
      toggleLoadingRequesting(false)
      toggleErrorRequesting(true, 4000)
    }
  }

  //function icon btn
  const handleIconBtn = (dataItem) => {
    setUrlPdf(dataItem.path)
    setShowPdf(true)
  }


  const handleOnClickGrid = (documento) => {
    setShowAws(true)
    setUrlPdf(documento.path)
    if (documento.path && documento.path !== '') {
      handleSetNameDocument(documento)
    }
    setShowModalPdf(true)
    setDocumentSelected(documento)
  }

  const closModalPdf = () => {
    handleDeleteFile();
    setProfiles([{
      documentName: '',
      document: null,
      upload: ''
    }])
    setFiles(null)
    setErrorExtensionFile(false)
    setShowModalPdf(false)
  }

  const openModalDelete = (dataItem) => {
    setSelectedDocumentGrid(dataItem)
    toggleShowModalDelete()
  }

  const toggleShowModalDelete = () => {
    setShowModalDelete(!showModalDelete)
  }

  const handleDeleteDocument = async () => {
    toggleShowModalDelete()
    if (!selectedDocumentGrid.dateToShow && selectedDocumentGrid.dateToShow === '') {
      setMessage('No se ha cargado un archivo a este documento')
      toggleErrorRequesting(true)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 4000)
      return
    }

    toggleLoadingRequesting(true)
    let messageError = 'Ocurrió un error al eliminar el documento'
    let userClientDocumentId = selectedDocumentGrid.id

    try {
      const contractorService = new ContractorService(url)
      let userClientDocument = await contractorService.deleteUserClientDocumentIdById(userClientDocumentId, token)
      if (userClientDocument && userClientDocument.data && Number(userClientDocument.statusCode) === 200) {
        toggleLoadingRequesting(false)
        handleDeleteFile();
        if (isFreelanceView) {
          getFreelanceData()
        } else {
          getContractorClientDocument()
          toggleCompletedRequesting(true)
        }
      } else {
        toggleLoadingRequesting(false)
        setMessage(messageError)
        toggleErrorRequesting(true)
        setTimeout(() => {
          toggleErrorRequesting(false)
        }, 4000)
      }
    } catch (error) {
      toggleLoadingRequesting(false)
      setMessage(messageError)
      toggleErrorRequesting(true)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 4000)
    }
  }


  //Pantalla de freelance
  useEffect(() => {
    if (!documentsFree || documentsFree.length === 0) return
    setDataDocuments(documentsFree)
    toggleLoadingRequesting(false)
  }, [documentsFree])


  const handleOpenModalForms = (formulario) => {
    let formPath = (formulario.path) ? formulario.path : ''
    let pathSave = ''
    if (formPath) {
      let split = formPath.split('/')
      let pathSplit = (split) ? `${split[3]}/${split[4]}/${split[5]}/${split[6]}/${split[7]}/${split[8]}` : ''
      let pathToSave = (pathSplit) ? pathSplit.split('?')[0] : ''
      pathSave = (pathToSave) ? pathToSave : ''
    }
    setShowModalForms(true)
    setPathDocumentSync(formulario.path)
    setPathToSave(pathSave)
    setDocumentSelected(formulario)
  }

  const handleCloseModalForm = () => {
    setShowModalForms(false)
    setDocumentSelected({})
  }

  const onClickSelectRow = (row) => {
    let copyDocuments = [...dataDocuments]
    copyDocuments = copyDocuments.map((doc) => {
      doc.selected = row.id === doc.id ? true : false
      return doc
    })

    setDataDocuments(copyDocuments)
  }

  const uploadFormDocument = () => {
    uploadFormAnwsered(documentSelected, setShowModalForms)
  }


  const uploadFile = async () => {
    if (isFreelanceView) await handleUploadDocFree(files, documentSelected, setShowAws, setLoadingDialog)
    else await handleOnChangeUpload(files)
  }

  const handleSelectFile = (ref, dataItem) => {
    setDataItemSelected(dataItem)
    ref.current.click()
  }
  const isExternalSignature = false

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file && file.type === 'application/pdf') {
      const reader = new FileReader()
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1]
        const updatedProfiles = [{
          documentName: file.name,
          document: file,
          upload: base64String
        }]
        setProfiles(updatedProfiles)
        setShowAws(false)
        setSelectedFileBase64(base64String)

        const blob = b64toBlob(base64String, 'application/pdf')
        setBlobUrl(blob)
        setFiles(e)
      }
      reader.readAsDataURL(file)
    } else {
      setErrorExtensionFile(true)
      setFiles(null)
    }
  }

  const onSelectRow = (e, dataItem) => {
    if (isExternalSignature) {
      if (dataItem && dataItem.url) {
        const blob = b64toBlob(dataItem.url, 'application/pdf')
        setBlobUrl(blob)
        setFileSelected(dataItem.url)
      }
    } else {
      let url = (dataItem && dataItem.url) ? dataItem.url : ''
      if (url) {
        const blob = b64toBlob(url, 'application/pdf')
        setBlobUrl(blob)
        setFileSelected(url)
      }
    }
  }

  const headerColumnOne = (props) => {
    return <span className='siganturePackageRequestProfileView-header-cell-one'>{props.title}</span>
  }

  const headerColumnTwo = (props) => {
    return <span className='siganturePackageRequestProfileView-header-cell-two'>{props.title}</span>
  }

  const cellColumnOne = (props) => {
    let subtitle = (props.dataItem.upload && props.dataItem.upload !== '') ? t('siganturePackageRequestProfileView.status.registered') : t('siganturePackageRequestProfileView.status.pending')
    let fileName = props.dataItem.documentName || t('siganturePackageRequestProfileView.status.pending')

    return (
      <td className={`siganturePackageRequestProfileView-cell-one ${props.dataItem.selected ? 'siganturePackageRequestProfileView-cell-selected' : ''}`} onClick={(e) => onSelectRow(e, props.dataItem)}>
        <div className=''>
          <div className='contractingRegistrationDocumentsView-container-span'>
            <span className='contractingRegistrationDocumentsView-span-name'>
              {fileName}
            </span>
          </div>
          <div>
            <span>
              {subtitle}
            </span>
          </div>
        </div>
      </td>
    )
  }

  const cellColumnTwo = (props) => {
    return (
      <td className={`documentPansiganturePackageRequestProfileViewelBarExpediente-cell-two ${props.dataItem.selected ? 'siganturePackageRequestProfileView-cell-selected' : ''}`} onClick={(e) => onSelectRow(e, props.dataItem)}>
        {!isExternalSignature &&
          <>
            <div
              className='contractingRegistrationDocumentsView-btn-upload'
              onClick={() => handleSelectFile(inputFileRef, props.dataItem)}
            >
              <p>{t('siganturePackageRequestProfileView.btn.upload')}</p>
            </div>
            <div
              className='cellActions-mobileExpanded'
              onClick={() => handleSelectFile(inputFileRef, props.dataItem)}
            >
              <img
                className='cellActions-icon-arrow'
                alt={'cellActions-arrow'}
                src={ArrowBtnMobile}
              />
            </div>
          </>
        }
      </td>
    )
  }

  return (
    <div className="contractingRegistrationDocumentsView-container">
      {
        isLoading ? (
          <SimpleLoading />
        ) : (
          <>
            {showLoadingRequesting ? (<DialogSystemGLPure showLoadingRequesting={showLoadingRequesting} toggleLoadingRequesting={toggleLoadingRequesting} />) : null}
            {showErrorRequesting ? (<DialogSystemGLPure showErrorRequesting={showErrorRequesting} toggleErrorRequesting={toggleErrorRequesting} message={message} />) : null}
            {showCompletedRequesting ? (<DialogSystemGLPure showCompletedRequesting={showCompletedRequesting} toggleCompletedRequesting={toggleCompletedRequesting} />) : null}

            <Grid container lg={12} md={12} sm={12} xs={12}>
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className=""
              >
                <Grid item className="contractingRegistrationDocumentsView-gridContainer">
                  <GridSelectionHLPure
                    skip={0}
                    take={5}
                    dataGrid={dataDocuments}
                    filter={true}
                    styleGeneral={true}
                    styleGeneralClass={"contractingRegistrationDocumentsView-general-grid"}
                    pageable={true}
                    columnTwo={true}
                    titleRow1={t("contractingRegistrationDocumentsView.title.cell.1")}
                    titleRow2={t("contractingRegistrationDocumentsView.title.cell.5")}
                    headerColumnOne={headerColumnOneForms}
                    headerColumnTwo={headerColumnTwoForms}
                    cellColumnOne={cellColumnOneForms}
                    cellColumnTwo={cellColumnTwoForms}
                    styleGrid={{ height: heightGrid }}
                  />
                </Grid>
              </Grid>
            </Grid>
            {showPdf ?
              <div>
                <div className="contractingRegistrationDocumentsView-container-pdf-btns">
                  <div className="contractingRegistrationDocumentsView-container-btn-seconday">
                    <ButtonHLPure
                      nameBtn={back}
                      primary={false}
                      onClickBtn={(event) => onHandleBack(event)}
                    />
                  </div>
                  <div className="contractingRegistrationDocumentsView-container-btn-seconday">
                    <ButtonHLPure
                      nameBtn={t("contractingRegistrationDocumentsView-btn-close-document")}
                      onClickBtn={closModalPdf}
                    />
                  </div>
                  <ButtonHLPure
                    nameBtn={next}
                    primary={true}
                    onClickBtn={(event) => hanldeContinueBtn(event)}
                  />
                </div>
                <Grid
                  className="pdf-container"
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                >
                  {pdfAws}
                </Grid>
              </div>
              : ''
            }
            <div className="contractingRegistrationDocumentsView-container-btns">
              <div className="contractingRegistrationDocumentsView-container-btn-seconday">
                <ButtonHLPure
                  nameBtn={back}
                  primary={false}
                  onClickBtn={(event) => onHandleBack(event)}
                />
              </div>
              <ButtonHLPure
                nameBtn={next}
                primary={true}
                onClickBtn={(event) => hanldeContinueBtn(event)}
              />
            </div>
            {showModalPdf && (
              <InteractiveDialog
                title={t('contractingRegistrationDocumentsView.uploadDocument')}
                onClose={closModalPdf}
                dialogSize='G'
                cancelBtnTitle={t('contractingRegistrationDocumentsView.buttonCancel')}
                saveBtnTitle={t('button.save')}
                onSave={() => uploadFile(inputFileRef, {})}
              >

                <div className='contractingRegistrationDocumentsView-modal-content'>
                  <div className='contractingRegistrationDocumentsView-modal-left-column'>
                    {documentSelected && documentSelected.name && (
                      <div className='contractingRegistrationDocumentsView-document-name'>
                        <LabelHLPure text={t('contractingRegistrationDocumentsView.documentSolicitud')} />
                        <span>{documentSelected.name}</span>
                      </div>
                    )}

                    <div className='contractingRegistrationDocumentsView-upload-section'>
                      <div className='contractingRegistrationDocumentsView-upload-control'>
                        <LabelHLPure text={t('contractingRegistrationDocumentsView.documentUploaded')} />
                        <div className='contractingRegistrationDocumentsView-upload-button'>
                          <input
                            ref={inputFileRef}
                            type='file'
                            accept='application/pdf'
                            style={{ display: 'none' }}
                            onClick={(e) => (e.target.value = null)}
                            onChange={handleFileChange}
                          />

                          <GridSelectionHLPure
                            styleGeneral={true}
                            styleGeneralClass={'siganturePackageRequestProfileView-general-grid'}
                            pageable={false}
                            skip={0}
                            take={profiles.length}
                            dataGrid={profiles}
                            filter={false}
                            columnTwo={true}
                            titleRow1={t('signatureRequestProfile.col1.title')}
                            titleRow2={t('signatureRequestProfile.col4.title')}
                            headerColumnOne={headerColumnOne}
                            headerColumnTwo={headerColumnTwo}
                            cellColumnOne={cellColumnOne}
                            cellColumnTwo={cellColumnTwo}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='contractingRegistrationDocumentsView-modal-right-column'>
                    <div className='contractingRegistrationDocumentsView-pdf-viewer'>
                      {showAWS && urlPdf ? (
                        <div className='contractingRegistrationDocumentsView-pdf-container'>
                          {pdfAws}
                        </div>
                      ) : null}

                      {selectedFileBase64 && !showAWS ? (
                        <div className='contractingRegistrationDocumentsView-pdf-container'>
                          {pdf}
                        </div>
                      ) : null}

                    </div>
                  </div>
                </div>
              </InteractiveDialog>
            )}
            {
              showModalDelete ?
                <DialogYesNoHLPure
                  titleDialog={t("contractingRegistrationDocumentsView.title.dialgo.delete.doc")}
                  textBtnCancel={t("button.cancel")}
                  handleSubmit={handleDeleteDocument}
                  saveBtn={t("button.delete")}
                  cancel={toggleShowModalDelete}
                >
                  <div className="dialogYesNoHLPure-childrenBody">
                    <p>{`¿${t("contractingRegistrationDocumentsView.label.dialgo.delete.doc")} ${selectedDocumentGrid.name}?`}</p>
                  </div>
                </DialogYesNoHLPure>
                : null
            }
            {
              showModalForms && (
                <DialogFormHLPure
                  titleDialog={t("contractingRegistrationDocumentsView.form.title")}
                  cancel={() => handleCloseModalForm()}
                >
                  <SyncfusionPDFViewer
                    documentPath={pathDocumentSync}
                    pathToSave={pathToSaveSync}
                    serviceUrl={process.env.REACT_APP_SERVICE_URL_PDF_VIEWER_SYNCFUSION}
                    style={{ height: '640px' }}
                    MagnificationTool
                    UndoRedoTool
                    SubmitForm
                    saveDocument={uploadFormDocument}
                  />
                  <div className="contractingRegistrationDocumentsView-btn-form">
                    <ButtonHLPure
                      nameBtn={t("dialogDeleteSignature.buttonCancel")}
                      onClickBtn={handleCloseModalForm}
                    />
                  </div>
                </DialogFormHLPure>
              )
            }
          </>
        )
      }
    </div>
  );
};

export default ContractingRegistrationDocumentsView;